import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const ClydesdaleBankPage = () => {
  return (
    <LenderPageTemplate
      lenderName="Clydesdale Bank"
      slug="/lenders/mis-sold-clydesdale-bank-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default ClydesdaleBankPage
